import { IAuditLogEntry } from '@dadohr/shared/domainTypes/auditLog';
import { generateToDocFn } from '@dadohr/shared/domainTypes/document';

export const toAuditLogEntryDoc = generateToDocFn<IAuditLogEntry>();
